<template>
    <b-col lg="4"
           class="header-payout">
        <router-link :to="{ name: 'Payout' }"
                     v-if="hasPacket"
                     class="button--primary">Payout</router-link>
        <button v-else
                :disabled="true"
                :type="'button'"
                class="button--primary">
            Payout
        </button>
    </b-col>
</template>
<script>
    export default {
        computed: {
            hasPacket () {
                return this.$store.getters.user.position != 0
            }
        }
    }
</script>
<style lang="scss" scoped>
    @media(min-width: 992px) {
        .header-payout{
            padding-left: 20px !important;
        }

        .button--primary{
            display: block;
            line-height: 42px;
        }
    }
    
    @media(max-width: 991px){
        .header-payout{
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/header/bottombar/HeaderPayout.vue